import React from "react";
import { useContent } from "../lib/content";
import { isHtmlString, normalizeRichTextHtml } from "../lib/sanitize";
import { controlledTypeStyle } from "../lib/typography";

function fontSize(value, fallback, min, max) {
  const n = Number(value);
  const safe = Number.isFinite(n) ? Math.min(max, Math.max(min, n)) : fallback;
  return `${safe}px`;
}

export default function CustomSections() {
  const { content } = useContent();
  const sections = content?.custom_sections ?? [];
  const leftHeadingSize = fontSize(content?.typography_custom_section_heading_size, 48, 20, 72);

  if (!sections.length) return null;

  return (
    <div>
      {sections.map((s, i) => {
        const anchor = (s.anchor || "").trim();
        if (!anchor) return null;
        const body = s.body || "";
        const hasTitle = Boolean((s.title || "").trim());
        const hasEyebrow = Boolean((s.eyebrow || "").trim());
        return (
          <section
            key={anchor + i}
            id={anchor}
            data-testid={`custom-section-${anchor}`}
            className="scroll-effect-section relative py-24 md:py-32 border-t border-bone-50/5"
          >
            <div className="container grid md:grid-cols-12 gap-12">
              {hasEyebrow && !hasTitle && (
                <div className="md:col-span-12 font-mono text-[10px] uppercase tracking-[0.3em] text-ember">
                  {s.eyebrow}
                </div>
              )}
              {hasTitle && (
                <div className="md:col-span-4">
                  {s.eyebrow && (
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-ember mb-4">
                      {s.eyebrow}
                    </div>
                  )}
                  {s.title && (
                    <h2
                      className="font-display text-4xl md:text-5xl tracking-tightest leading-[0.95] text-balance"
                      style={controlledTypeStyle({
                        fontSize: leftHeadingSize,
                        font: content?.typography_custom_section_heading_font,
                      })}
                      data-testid={`custom-section-title-${anchor}`}
                    >
                      {s.title}
                    </h2>
                  )}
                </div>
              )}
              <div
                className={`text-base md:text-lg ${
                  hasTitle ? "md:col-span-7 md:col-start-6" : "md:col-span-12"
                }`}
              >
                {isHtmlString(body) ? (
                  <div
                    className="prose-rich"
                    data-testid={`custom-section-body-${anchor}`}
                    dangerouslySetInnerHTML={{ __html: normalizeRichTextHtml(body) }}
                  />
                ) : (
                  <div
                    className="text-bone-200/70 leading-relaxed whitespace-pre-line"
                    data-testid={`custom-section-body-${anchor}`}
                  >
                    {body}
                  </div>
                )}
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
